import React from 'react';
export const WordPressBlocksContext = React.createContext({});
/**
 * WordPressBlocksProvider is used as a central store for the available list of WordPressBlock types.
 * @param props
 * @returns
 */
export function WordPressBlocksProvider(props) {
    const { children, config } = props;
    return (React.createElement(WordPressBlocksContext.Provider, { value: config }, children));
}
